import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function AlertsResetWarning({ sx }) {
  const { t } = useTranslation();
  return (
    <Alert severity="warning" sx={{ fontSize: "0.8rem", ...sx }}>
      {t("area.alertsReset")}
    </Alert>
  );
}
